module.exports = __webpack_public_path__ + "img/3.01e2963d.png";